module.exports = __webpack_public_path__ + "img/productive-unproductive-summary.fa59c858.png";